// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectVariantIcon_root__d_PxX"};